module.exports = __webpack_public_path__ + "img/IMG-20200716-WA0009.6e02f994.jpg";